import React from 'react';
import cn from 'classnames';
import { bbCodeToHtml } from '../../../../../../../utils/formUtils';
import { Visibility } from '../../../../../../../types/common-types';
import './style.scss';
import Icon from '../../../../../../../components/common/icon';

interface ListItemProp {
  value: string;
  date?: string;
  error?: boolean;
  visibility: Visibility;
}
interface Props {
  id?: string;
  visibility: Visibility;
  extra: { header?: string; content: Array<ListItemProp>; footer?: string };
}

const List: React.FC<Props> = ({ id, visibility, extra }) => {
  const { header, content, footer } = extra;
  return (
    <div
      id={id}
      styleName={cn('list', {
        hidden: visibility === Visibility.Hidden,
      })}
    >
      <div
        styleName="list__header"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: bbCodeToHtml(header),
        }}
      />
      {content.map((item: ListItemProp) => (
        <div
          styleName={cn('list__item', {
            disabled: item.visibility === Visibility.Disabled,
            error: item.error,
          })}
          key={item.value}
        >
          <Icon styleName="list__item__icon" value="bullet" />
          <div styleName="list__item__row">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: bbCodeToHtml(item.value),
              }}
            />
            <div>{item.date}</div>
          </div>
        </div>
      ))}
      <div
        styleName="list__footer"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: bbCodeToHtml(footer),
        }}
      />
    </div>
  );
};
export default List;
